<template>
  <div class="create-edit-receipt-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreateReceipt">Nova receita</h1>
      <h1 class="subtitle is-4" v-else>Editar receita</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-12">
          <div
            class="field"
            :class="{
              'input-error':
                !$v.receipt.name.$required && $v.receipt.name.$error
            }"
          >
            <label class="label" for="receiptName">Nome da Receita</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="receiptName"
                name="receiptName"
                v-model.trim="$v.receipt.name.$model"
              />
              <b-tooltip
                label="Campo requerido"
                type="is-danger"
                v-if="!$v.receipt.name.$required && $v.receipt.name.$error"
              >
                <span class="error-icon has-text-danger"
                  ><i class="mdi mdi-alert-circle"></i
                ></span>
              </b-tooltip>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <div class="field">
            <label class="label" for="receiptNumber">Número da receita</label>
            <div class="control">
              <input
                type="text"
                class="input"
                id="receiptNumber"
                name="receiptName"
                v-model.trim="receipt.number"
              />
            </div>
          </div>
        </div>

        <div class="column is-12">
          <label class="label">Selecione a categoria</label>
          <b-field>
            <b-autocomplete
              expanded
              v-model="categorySearchText"
              :data="categoriesList"
              placeholder="Buscar categoria"
              field="name"
              :loading="isFetching"
              :keep-first="true"
              @keyup.native="getCategoriesAsyncData"
              @select="option => (selectedCategory = option)"
            >
              <template slot-scope="props">
                <span>{{ props.option.name }}</span>
              </template>
              <template slot="empty">
                Nenhum resultado encontrado
              </template>
            </b-autocomplete>
            <p class="control">
              <a class="button is-primary" @click="addCategoryToList">+</a>
            </p>
          </b-field>
        </div>

        <div class="column is-12 " v-if="receipt.categories.length">
          <div class="categories-table">
            <table class="table is-fullwidth ">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(category, index) in receipt.categories"
                  v-bind:key="category.id + index"
                >
                  <td>{{ category.name }}</td>
                  <td><a @click="removeCategory(index)">Remover</a></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="column is-12 message-holder" v-else>
          <div class="no-items-message has-text-centered is-centered">
            Nenhum item adicionado à receita.
          </div>
        </div>
        <div class="footer column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium is-primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="isPendingAction"
          >
            <span v-if="isCreateReceipt">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
import CategoryService from "../../services/CategoryService";
import QueryBuilder from "../../helpers/QueryBuilder";
import utils from "../../helpers/debounce";

export default {
  name: "CreateEditReceiptModal",
  data: function() {
    return {
      isCreateReceipt: true,
      isPendingAction: false,
      receipt: {},
      categorySearchText: "",
      categoriesList: [],
      isFetching: false,
      selectedCategory: {}
    };
  },
  computed: {
    ...mapState({ packings: state => state.packing.packings })
  },
  methods: {
    ...mapActions({
      createReceipt: "receipt/createReceipt",
      editReceipt: "receipt/editReceipt"
    }),
    validateBeforeSubmit() {
      this.$v.receipt.$touch();
      if (this.$v.receipt.$invalid) {
        return;
      }

      if (this.isCreateReceipt) {
        this.createReceipt(this.receipt)
          .then(() => {
            NotificationsWrapper.success("Receita cadastrada com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar a receita. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.editReceipt(this.receipt)
          .then(() => {
            NotificationsWrapper.success("Receita atualizada com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar a receita. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    },
    addCategoryToList() {

      this.receipt.categories.push(this.selectedCategory);

    },
    removeCategory(index) {
      this.receipt.categories = this.receipt.categories.filter((item, i) => {
        return i !== index;
      });
    },
    getCategoriesAsyncData: utils.debounce(function() {
      this.categoriesList = [];
      let query = {
        name: this.categorySearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      CategoryService.getCategories(query)
        .then(({ data }) => {
          this.categoriesList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300)
  },
  validations: {
    receipt: {
      name: { required }
    }
  },
  props: {
    receiptParam: {}
  },
  created() {
    if (!this.receiptParam.id) {
      this.isCreateReceipt = true;
      this.receipt = { name: "", categories: [] };
    } else {
      this.receipt = this.receiptParam;
      this.isCreateReceipt = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.categories-table,
.packing-list-holder {
  max-height: 250px;
  overflow: auto;
}

.table-holder {
  height: 250px;

  &.message-holder {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
